import axios from 'axios'
import HttpService from './http.service'
import constants from '../constants'

const toLiveeSegment = segment => {
  const toLiveeFilter = filter => ({
    field: filter.field,
    operator: filter.operator === '=' ? '==' : filter.operator,
    value: filter.value,
  });
  const filters = ((segment.search_criteria && segment.search_criteria.filters) || []).map(toLiveeFilter);
  return {
    ...segment,
    search_criteria: { filters }
  }
}

const handleResponse = (res) => {
  const response = res.data;
  if (response.error) {
    return Promise.reject({ message: response.error.message });
  }
  return response.result;
}

class SegmentsService extends HttpService {
  fetchSegments(sessionId) {
    return axios
      .get(`${constants.API.URL}/accesscontrol/segments/${sessionId}`, this.getOptions())
      .then(handleResponse)
      .then(res => (res.segments || []).map(toLiveeSegment))
      .catch(this.onError)
  }

  segmentPreview(sessionId, segmentId, offset = 0, limit = 10) {
    return axios
      .get(`${constants.API.URL}/accesscontrol/segments_preview/${sessionId}`, this.getOptions({ params: { segment_id: segmentId, offset, limit }}))
      .then(handleResponse)
      .then(res => (res.users || []))
      .catch(this.onError)
  }

  postSegment(sessionId, segment) {
    return axios
      .post(`${constants.API.URL}/accesscontrol/segment/${sessionId}`, segment, this.getOptions())
      .then(handleResponse)
      .catch(this.onError)
  }

  putSegment(sessionId, segmentId, segment) {
    return axios
      .post(`${constants.API.URL}/accesscontrol/segment_update/${sessionId}/${segmentId}`, segment, this.getOptions())
      .then(handleResponse)
      .catch(this.onError)
  }

  delSegment(sessionId, segmentId) {
    return axios
      .delete(`${constants.API.URL}/accesscontrol/segment/${sessionId}`, this.getOptions({ params: { segment_id: segmentId}}))
      .then(handleResponse)
      .catch(this.onError)
  }
}

export default new SegmentsService()
